/**
 * Lab Aggregate My P/L (old) — `/aggregate/master-dashboard`
 * (`AggregateMasterDashboardCtrl` + `getMasterDashboardAggregator`).
 */

/** Sub Games from Lab `$scope.getSubGames` (old Aggregate master-dashboard). */
export const LAB_MY_PNL_SUB_GAMES = [
  'All',
  'Card Game',
  'Live Casino',
  'Premium SportsBook',
  'Cricket',
  'Tennis',
  'Soccer',
  'Premium Bookmaker',
  'Premium Fancy',
] as const

export type LabMyPnlSubGame = (typeof LAB_MY_PNL_SUB_GAMES)[number]

/**
 * Lab hides Event Name / Event Type for casino / card on the New page;
 * old Aggregate UI still shows them, but drills use isCardGame / isLiveCasino.
 * Keep the same hide for Card / Live Casino — picker is unused there in practice.
 */
export function labMyPnlHidesEventFilters(subGame: string): boolean {
  return subGame === 'Live Casino' || subGame === 'Card Game'
}

/** Lab `$scope.getTypes` on Aggregate master-dashboard (old). */
export function labMyPnlEventTypes(subGame: string): string[] {
  if (subGame === 'All') return ['All']
  return ['All', 'Match Odds', 'Completed Match', 'Tied Match', 'Bookmaker', 'Session']
}

/**
 * Aggregate-API / Lab excel gate — reject when `ceil(|to−from| / 1d) > 31`.
 * (Lab New My P/L uses 15; old Aggregate downloadCsv uses 31.)
 */
export const LAB_MY_PNL_MAX_RANGE_DAYS = 31

export function labMyPnlRangeDayCount(from: string, to: string): number {
  const a = Date.parse(`${from}T00:00:00`)
  const b = Date.parse(`${to}T00:00:00`)
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 0
  return Math.ceil(Math.abs(b - a) / (1000 * 60 * 60 * 24))
}

export function labMyPnlRangeTooLong(from: string, to: string): boolean {
  return labMyPnlRangeDayCount(from, to) > LAB_MY_PNL_MAX_RANGE_DAYS
}

/** Lab `balance-up` / `balance-down`: strictly positive is green; zero and loss are red. */
export function labMyPnlTone(value: number): 'profit' | 'loss' {
  return value > 0 ? 'profit' : 'loss'
}

/** Premium Sportsbook rows hide Market / User in Lab. */
export function labMyPnlHidesDrilldown(gameName: string): boolean {
  const n = gameName.trim().toLowerCase()
  return n === 'premium-sportsbook' || n === 'premium sportsbook'
}

/** True when applied filters narrow beyond the default All Sub Game / event / type. */
export function labMyPnlFiltersNarrowed(applied: {
  subGame: string
  eventId: string
  typeName: string
}): boolean {
  return (
    (Boolean(applied.subGame) && applied.subGame !== 'All') ||
    (Boolean(applied.eventId) && applied.eventId !== 'All') ||
    (Boolean(applied.typeName) && applied.typeName !== 'All')
  )
}
